import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollRevealImages from './components/ScrollRevealImages';
const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const About = lazy(() => import('./pages/About'));
const Blog = lazy(() => import('./pages/Blog'));
const Contact = lazy(() => import('./pages/Contact'));
const Auth = lazy(() => import('./pages/Auth'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const AIConsulting = lazy(() => import('./pages/AIConsulting'));
const CustomAISolutions = lazy(() => import('./pages/CustomAISolutions'));
const Packages = lazy(() => import('./pages/Packages'));
const DashboardPackages = lazy(() => import('./pages/DashboardPackages'));
const Documentation = lazy(() => import('./pages/Documentation'));

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-nvidia-dark-800 via-nvidia-dark to-nvidia-dark-800 text-white">
      <ScrollRevealImages />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#252525',
            color: '#fff',
            border: '1px solid #333333',
          },
        }}
      />
      <Navbar />
      <main className="flex-grow">
        <div className="min-h-[calc(100vh-4rem)] bg-gradient-radial from-nvidia-dark-700/50 via-transparent to-transparent">
          <Suspense fallback={<div className="container mx-auto px-6 py-16 text-center text-gray-400">Loading…</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/packages" element={<Packages />} />
              <Route path="/dashboard/packages" element={<DashboardPackages />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/ai-consulting" element={<AIConsulting />} />
              <Route path="/custom-ai-solutions" element={<CustomAISolutions />} />
              <Route path="/docs" element={<Documentation />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
